export function traceAction(traceActionRecord) {
  if (traceActionRecord.isValid() && newRelicLoaded()) {
    newrelic.addPageAction(traceActionRecord.name, {
      beforeRoutingTimestamp: traceActionRecord.beforeRoutingTimestamp,
      completedRoutingTimestamp: traceActionRecord.completedRoutingTimestamp,
      routingDuration: traceActionRecord.duration(),
      firstMount: traceActionRecord.firstMount,
      appChange: traceActionRecord.appChange,
      gamma: traceActionRecord.gamma
    });

    newrelic.setCustomAttribute('firstMount', traceActionRecord.firstMount);
    newrelic.setCustomAttribute('routingDuration', traceActionRecord.duration());
    newrelic.setCustomAttribute('appChange', traceActionRecord.appChange);
    newrelic.setCustomAttribute('gamma', traceActionRecord.gamma);
  }
}

export function setCurrentRouteName(name) {
  if (newRelicLoaded()) {
    newrelic.setCurrentRouteName(name)
  }
}

export function setCustomAttribute(name, value) {
  if (newRelicLoaded()) {
    newrelic.setCustomAttribute(name, value)
  }
}

function newRelicLoaded() {
  return typeof(newrelic) !== "undefined" && newrelic !== null
}

export class TraceActionRecord {
  constructor(name) {
    this.name = name;
    this.beforeRoutingTimestamp = 0;
    this.completedRoutingTimestamp = 0;
    this.firstMount = false;
    this.appChange = false;
    this.gamma = false;
  }

  recordBefore() {
    this.beforeRoutingTimestamp = Date.now();
  }

  recordCompleted() {
    this.completedRoutingTimestamp = Date.now();
  }

  isValid() {
    return this.beforeRoutingTimestamp > 0
  }

  duration() {
    return this.completedRoutingTimestamp - this.beforeRoutingTimestamp
  }
};



// WEBPACK FOOTER //
// ./app/scripts/lib/util/tracing/routing-tracer.js